import { faqData } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="w-full px-4 md:px-6 lg:px-12 py-12 md:py-16 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-8">常见问题</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {faqData.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-lg border border-background-200/70 p-5"
            >
              <h3 className="text-sm font-semibold text-foreground-900 mb-2 flex items-start gap-2">
                <span className="text-accent-500 font-bold flex-shrink-0">Q</span>
                {item.question}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed flex items-start gap-2">
                <span className="text-foreground-400 font-bold flex-shrink-0">A</span>
                {item.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}